<template>
  <div>
    <el-dialog title="保存模板" :visible.sync="dialogTemplate" append-to-body width="30%">
      <el-input :disabled="disabled" size="mini" v-model.trim="templateName" placeholder="请输入模板名称"></el-input>
      <div>
        <selectIcon ref="selectIcon" @getVal="valGet"></selectIcon>
        <el-checkbox v-model="checked" v-if="userId == 'super' && temType == 0">设置为系统模板</el-checkbox>
        <!-- <el-checkbox @change="xitong" v-model="changyong" v-if="userId == 'super' && temType == 0 && category == 9">设置为系统常用模板模板</el-checkbox>
				<el-checkbox @change="geren" v-model="gerenChangyong" v-if="userId !== 'super' && temType == 0 && category == 9">设置为个人常用模板模板</el-checkbox> -->
        <el-button class="selectIcon" type="text" size="mini" @click="select">选择图标</el-button>
        <img v-if="tubiaoClass" :src="isIcon(tubiaoClass)" alt="" style="width: 22px;height: 22px;">
        <!-- <i :class="tubiaoClass" class="iconfont"></i> -->
        <div>
          <el-tag v-for="(item,index) in temClass" :key="item.ID" @click.native="selectClass(item,index)" size="medium" :type="item.TEMPTYPE == 4 ? 'success' : 'info'" :hit="index == isHit ? true : false">{{ item.NAME }}</el-tag>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogTemplate = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="setTemplate">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
	import {
		AddTemplate,
	} from "@/api/modules/basicData/task";
	import {
		mapState
	} from 'vuex'
	import selectIcon from './selectIcon'
	export default {
		data() {
			return {
				dialogTemplate: false,
				templateName: '',//模板名称
				tubiaoClass: '',
				isHit: null, // 当前选中的一个分组index
				temClassObj: {},//分组obj
				content: '',
				checked: false,
				changyong: false,
				disabled: false,
				gerenChangyong: false,
				category:4,
				temClass:[],
				allTemplate:[],
				// cy: false
			}
		},
		props: {
			body: Boolean,
			temType: Number,
		},
		components:{
			selectIcon
		},
		computed: {
			...mapState({
				userId: state => state.task.userId,

				category1: state => state.template.category,
				temClass1: state => state.template.temClass,
				allTemplate1: state => state.template.allTemplate,

				category2: state => state.task.category,
				temClass2: state => state.task.temClass,
				allTemplate2: state => state.task.allTemplate,
			}),
		},
		methods: {
			// xitong(val){
			// 	if(val){
			// 		this.templateName = '系统常用模板';
			// 		this.disabled = true;
			// 		this.cy = val;
			// 	} else {
			// 		this.templateName = '';
			// 		this.disabled = false;
			// 		this.cy = val;
			// 	}
			// },
			geren(val){
				if(val){
					this.templateName = '系统常用模板';
					this.disabled = true;
					this.cy = val;
				} else {
					this.templateName = '';
					this.disabled = false;
					this.cy = val;
				}
			},
			open() {
				this.dialogTemplate = true;
				if(this.category1){
					this.category=this.category1
				}else{
					this.category=this.category2
				}

				if(this.temClass1.length>0){
					this.temClass=this.temClass1
				}else{
					this.temClass=this.temClass2
				}
				if(this.allTemplate1.length>0){
					this.allTemplate=this.allTemplate1
				}else{
					this.allTemplate=this.allTemplate2
				}
				console.log('category分类 ',this.category);
			},
			select(){
				this.$refs.selectIcon.innerVisible = true;
			},
			valGet(val){
				this.tubiaoClass = val
			},
			isIcon(val){
				if(val){
					return require("@/assets/icon/"+val)
				}
			},
			getNowFormatDate() {
				var date = new Date();
				var seperator1 = "-";
				var seperator2 = ":";
				var month = date.getMonth() + 1;
				var strDate = date.getDate();
				if (month >= 1 && month <= 9) {
					month = "0" + month;
				}
				if (strDate >= 0 && strDate <= 9) {
					strDate = "0" + strDate;
				}
				var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate +
					" " + date.getHours() + seperator2 + date.getMinutes() +
					seperator2 + date.getSeconds();
				return currentdate;
			},
			setTemplate() {
				var thisTime = this.getNowFormatDate()
				let bol = 0;
				if(!this.templateName){
					this.$message({
							message: '请输入模板名称',
							type: 'warning'
						});
						return false
				}
				// console.log(this.checked,'this.checked');
				// console.log(this.temClassObj.TEMPTYPE,'this.temClassObj.TEMPTYPE');
				if (this.checked) {
					bol = 2;
					// this.temClassObj
					if(this.temClassObj.TEMPTYPE !== 4){
						this.$message({
							message: '请选中系统分组！',
							type: 'warning'
						});
						return false
					}
				}
				let ttt = this.allTemplate.find((value, index, arr) => {
					return value.NAME == this.templateName
				})
				// console.log(ttt,'ttt');
				if(ttt){
					this.$message({
						message: '重复模板名，请更改！',
						type: 'warning'
					});
					return false
				}
				console.log(this.allTemplate,'this.allTemplate');
				let arr2 = []
				this.allTemplate.forEach(c => {
					if(c.PID == this.temClassObj.ID){
						arr2.push(c)
					}
				})
				console.log(arr2,'arr2')
				let tempIndex = arr2.length;
				console.log(tempIndex,'tempIndex')
				console.log(this.temClassObj.ID,'this.temClassObj.ID')
				if(!this.temClassObj.ID){
					this.$message({
						message: '请选择分组！',
						type: 'warning'
					});
					return false
				}
				AddTemplate(this.templateName, this.tubiaoClass, this.userId, thisTime, this.content, this.temType, tempIndex, this.temClassObj
					.ID, bol, this.category).then(
					res => {
						// console.log(res)
						if (res > 0) {
							this.$message.success("设置模板成功");
							// this.$root.$emit('refreshLeft',true)
							this.$store.commit("getAllTemplate");
							this.$store.commit("getAllTemplateLeft");
							this.$root.$emit('createdTemp',true)
							this.templateName = '';
							this.tubiaoClass = '';
						} else {
							this.$message.error("设置模板失败");
						}
					});
				this.dialogTemplate = false;
				if (this.body) {
					this.$emit("guanbi")
				}

			},
			selectClass(val, index) {
				console.log(val, "valvalvavla")
				this.temClassObj = val;
				this.isHit = index;
			},
		},
	}
</script>

<style scoped>
  .tubiao_div {
    word-wrap: break-word;
  }
</style>
